export default [
    {
        "id": 1,
        "slug": "global-goal-1-no-poverty",
        "name": "GLOBAL GOAL 1: No Poverty",
        "icon": "/images/goals/goal-1.svg"
    },
    {
        "id": 2,
        "slug": "global-goal-2-zero-hunger",
        "name": "GLOBAL GOAL 2: Zero Hunger",
        "icon": "/images/goals/goal-2.svg"
    },
    {
        "id": 3,
        "slug": "global-goal-3-good-health-and-well-being",
        "name": "GLOBAL GOAL 3: Good Health and Well-being",
        "icon": "/images/goals/goal-3.svg"
    },
    {
        "id": 4,
        "slug": "global-goal-4-quality-education",
        "name": "GLOBAL GOAL 4: Quality Education",
        "icon": "/images/goals/goal-4.svg"
    },
    {
        "id": 5,
        "slug": "global-goal-5-gender-equality",
        "name": "GLOBAL GOAL 5: Gender Equality",
        "icon": "/images/goals/goal-5.svg"
    },
    {
        "id": 6,
        "slug": "global-goal-6-clean-water-and-sanitation",
        "name": "GLOBAL GOAL 6: Clean Water and Sanitation",
        "icon": "/images/goals/goal-6.svg"
    },
    {
        "id": 7,
        "slug": "global-goal-7-affordable-and-clean-energy",
        "name": "GLOBAL GOAL 7: Affordable and Clean Energy",
        "icon": "/images/goals/goal-7.svg"
    },
    {
        "id": 8,
        "slug": "global-goal-8-decent-work-and-economic-growth",
        "name": "GLOBAL GOAL 8: Decent Work and Economic Growth",
        "icon": "/images/goals/goal-8.svg"
    },
    {
        "id": 9,
        "slug": "global-goal-9-industry-innovation-and-infrastructure",
        "name": "GLOBAL GOAL 9: Industry, Innovation and Infrastructure",
        "icon": "/images/goals/goal-9.svg"
    },
    {
        "id": 10,
        "slug": "global-goal-10-reduced-inequality",
        "name": "GLOBAL GOAL 10: Reduced Inequality",
        "icon": "/images/goals/goal-10.svg"
    },
    {
        "id": 11,
        "slug": "global-goal-11-sustainable-cities-and-communities",
        "name": "GLOBAL GOAL 11: Sustainable Cities and Communities",
        "icon": "/images/goals/goal-11.svg"
    },
    {
        "id": 12,
        "slug": "global-goal-12-responsible-consumption-and-production",
        "name": "GLOBAL GOAL 12: Responsible Consumption and Production",
        "icon": "/images/goals/goal-12.svg"
    },
    {
        "id": 13,
        "slug": "global-goal-13-climate-action",
        "name": "GLOBAL GOAL 13: Climate Action",
        "icon": "/images/goals/goal-13.svg"
    },
    {
        "id": 14,
        "slug": "global-goal-14-life-below-water",
        "name": "GLOBAL GOAL 14: Life Below Water",
        "icon": "/images/goals/goal-14.svg"
    },
    {
        "id": 15,
        "slug": "global-goal-15-life-on-land",
        "name": "GLOBAL GOAL 15: Life on Land",
        "icon": "/images/goals/goal-15.svg"
    },
    {
        "id": 16,
        "slug": "global-goal-16-peace-and-justice-strong-institutions",
        "name": "GLOBAL GOAL 16: Peace and Justice Strong Institutions",
        "icon": "/images/goals/goal-16.svg"
    },
    {
        "id": 17,
        "slug": "global-goal-17-partnerships-to-achieve-the-goal",
        "name": "GLOBAL GOAL 17: Partnerships to achieve the Goal",
        "icon": "/images/goals/goal-17.svg"
    },
    {
        "id": 18,
        "slug": "other",
        "name": "Other",
        "icon": "/images/goals/other-icon.svg"
    }
];


